import type { Options } from '@contentful/rich-text-react-renderer'
import { MARKS } from '@contentful/rich-text-types'

export const options: Options = {
  renderMark: {
    [MARKS.SUPERSCRIPT]: text => <sup className="text-[10px]">{text}</sup>
  }
}
